var updateHightlightOdds = (bettingSelection) => {
    $('.odds_box_up').removeClass('odds_box_up')            
    $('.subaccountform_up').removeClass('subaccountform_up')            
    $('.more_td_up').removeClass('more_td_up')            
    $('.accordion_content_2_up').removeClass('accordion_content_2_up')   
    $('.oddsdetails_up').removeClass('oddsdetails_up')    
    $('.btn_lebet_odd').removeClass('on')
    $('.btn_obt_odd').removeClass('on')
    $('.odd-column-item').removeClass('odd-column-item2')
    $('.ol-li-item').removeClass('active-item')
    $('.play-box-sty').removeClass('details-bg5')
    $('.play-box-sty').removeClass('white_text')
    $('.fz_16').removeClass('size-color-wit')
    $('.fz_16').addClass('size-color')
    $('.odds').removeClass('white_text')
    $('.play-box-style').removeClass('details-bg5')
    $('.play-box-style').removeClass('white_text')
    $('.play-box-style').removeClass('first-rad')
    $('.play-box').removeClass('active-play')
    $('.play-box').removeClass('border-top')
    $('.fz_14').removeClass('white_text')
    $('.odd-title').removeClass('white_text')
    $('.fz_16').removeClass('white_text')
    $('.odd-column').removeClass('details-bg5')
    $('.play-box').removeClass('details-bg5')
    $('.play-box'+' .item-fat').removeClass('white_text')

    _.forEach(bettingSelection, function(value,key){
        if(value.uniqueId && value.uniqueId != "") {
            if($('.oddsdetails.'+value.uniqueId).length > 0) {
                $('.oddsdetails.'+value.uniqueId).addClass('oddsdetails_up')
            }else if($('.odds_box.'+value.uniqueId).length > 0) {
                $('.odds_box.'+value.uniqueId).addClass('odds_box_up')
            } else if ($('.subaccountform.'+value.uniqueId).length > 0) {
                $('.subaccountform.'+value.uniqueId).addClass('subaccountform_up')
            } else if ($('.more_td.'+value.uniqueId).length > 0) {
                $('.more_td.'+value.uniqueId).addClass('more_td_up')
            } else if ($('.accordion_content_2.'+value.uniqueId).length > 0) {
                $('.accordion_content_2.'+value.uniqueId).addClass('accordion_content_2_up')
            } else if ($('.btn_lebet_odd.'+value.uniqueId).length > 0) {
                $('.btn_lebet_odd.'+value.uniqueId).addClass('on')
                
                if ($('.btn_obt_odd.'+value.uniqueId).length >0) {
                    $('.btn_obt_odd.'+value.uniqueId).addClass('on')
                }
            } else if ($('.odd-column-item.'+value.uniqueId).length>0) {
                $('.odd-column-item.'+value.uniqueId).addClass('odd-column-item2')
            } else if ($('.odd-column.'+value.uniqueId).length>0) {
                $('.odd-column.'+value.uniqueId).addClass('details-bg5')
                $('.fz_14.'+value.uniqueId).addClass('white_text')
                $('.odds.'+value.uniqueId).addClass('white_text')
            } else if ($('.play-box-sty.'+value.uniqueId).length >0) {
                $('.play-box-sty.'+value.uniqueId).addClass('details-bg5')
                $('.play-box-sty.'+value.uniqueId).addClass('white_text')
                $('.fz_16.'+value.uniqueId).addClass('size-color-wit')
                $('.fz_16.'+value.uniqueId).removeClass('size-color')
                $('.odds.'+value.uniqueId).addClass('white_text')
            } else if ($('.play-box-style.'+value.uniqueId).length >0) {
                $('.play-box-style.'+value.uniqueId).addClass('details-bg5')
                $('.play-box-style.'+value.uniqueId).addClass('white_text')
                $('.play-box-style.'+value.uniqueId).addClass('first-rad')
                $('.fz_14.'+value.uniqueId).addClass('white_text')
                $('.fz_16.'+value.uniqueId).addClass('white_text')
                $('.odds.'+value.uniqueId).addClass('white_text')
                $('.odd-title.'+value.uniqueId).addClass('white_text')
            } else if ($('.ol-li-item.'+value.uniqueId).length>0) {
                $('.ol-li-item.'+value.uniqueId).addClass('active-item')
            } else if($('.play-box.'+value.uniqueId).length>0) {
                $('.play-box.'+value.uniqueId).addClass('active-play')
                $('.play-box.'+value.uniqueId).addClass('border-top')
                $('.odds.'+value.uniqueId).addClass('white_text')
                if(value.bettype == '25') { // wm
                    $('.play-box.'+value.uniqueId).addClass('details-bg5')
                    $('.play-box.'+value.uniqueId+' .item-fat').addClass('white_text')
                }
            }
        }
    })
  }

export {
    updateHightlightOdds
}



// WEBPACK FOOTER //
// ./resources/score/js/common/common.js